import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "M31.999 8.328v-.017a2.05 2.05 0 0 0-.572-1.423l.001.001-2.811-2.856a1.98 1.98 0 0 0-1.417-.594 1.99 1.99 0 0 0-1.394.594L12.277 17.882l-6.102-6.216a1.98 1.98 0 0 0-1.393-.594H4.78a1.98 1.98 0 0 0-1.416.594L.576 14.545a2.054 2.054 0 0 0 0 2.857l-.001-.001 10.284 10.513c.356.361.848.588 1.393.594h.002a1.98 1.98 0 0 0 1.416-.594L31.427 9.769c.354-.368.571-.87.571-1.423zl-.001.001z"
  })
});
const Memo = /*#__PURE__*/memo(SvgCheck);
export default Memo;